// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact {
  padding: 100px 0 120px 0;
  width: 100%;
  max-width: 1250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.contact__title {
  color: #1e1c1a;
  font-size: 36px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 47px;
  margin-bottom: 20px;
  text-align: center;
}
.contact__img {
  width: 380px;
  height: 30px;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
}
.contact__text {
  max-width: 85%;
  margin: 24px auto 30px;
  color: #1e1c1a;
  font-size: 17px;
  letter-spacing: 0;
  line-height: 30px;
  text-align: center;
}
.contact__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  background-color: #1e1c1a;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.2;
  color: #fff;
  padding: 0 30px;
  outline: none;
  border: none;
}
.contact-wrapp {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Contact/Contact.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ;IACE,WAAW;EACb;AACF;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".contact {\n  padding: 100px 0 120px 0;\n  width: 100%;\n  max-width: 1250px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n}\n.contact__title {\n  color: #1e1c1a;\n  font-size: 36px;\n  font-weight: 900;\n  letter-spacing: 0;\n  line-height: 47px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n.contact__img {\n  width: 380px;\n  height: 30px;\n  @media screen and (max-width: 600px) {\n    width: 100%;\n  }\n}\n.contact__text {\n  max-width: 85%;\n  margin: 24px auto 30px;\n  color: #1e1c1a;\n  font-size: 17px;\n  letter-spacing: 0;\n  line-height: 30px;\n  text-align: center;\n}\n.contact__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 50px;\n  background-color: #1e1c1a;\n  font-size: 15px;\n  font-weight: bold;\n  line-height: 1.2;\n  color: #fff;\n  padding: 0 30px;\n  outline: none;\n  border: none;\n}\n.contact-wrapp {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
